import vars from '../helpers';
import Swiper, { Navigation, Pagination, Mousewheel } from 'swiper';

Swiper.use([Navigation, Pagination, Mousewheel]);
	
const $backgroundItem = $('.index__background__item');

if (vars.isMobile()) {
	$('.index__item--first').on('click', (e) => {
		let $target = $('.index__item.index__item--1');

		e.preventDefault();

		$('html, body').animate({
			scrollTop: $target.offset().top + $target.outerHeight() / 2 - vars.$window.outerHeight() / 2,
		}, 500);
	});

	vars.$window.on('scroll', () => {
		$('.index__item').each((index, item) => {
			let $item = $(item);

			if (vars.$window.scrollTop() + vars.$window.outerHeight() * (1 / 3) >= $item.offset().top) {
				$backgroundItem.each((bIndex, bItem) => {
					const $bItem = $(bItem);
			
					if (bIndex > index) {
						$bItem.removeClass('is-active');
					} else {
						$bItem.addClass('is-active');
					}
				});
			}
		});
	});
} else {
	const swiper = new Swiper($('.index__scroll .swiper-container')[0], {
		slidesPerView: 'auto',
		centeredSlides: true,
		mousewheel: true,
		speed: 1000,
	});
	
	swiper.on('slideChange', () => {
		$backgroundItem.each((index, item) => {
			const $item = $(item);
	
			if (index > swiper.activeIndex) {
				$item.removeClass('is-active');
			} else {
				$item.addClass('is-active');
			}
		});
	});
	
	$('.index__item').on('click', (e) => {
		let $this = $(e.currentTarget);
	
		if ($this.hasClass('index__item--first')) {
			e.preventDefault();
			swiper.slideTo(1);
		} else if (!$this.closest('.swiper-slide').hasClass('swiper-slide-active')) {
			swiper.slideTo($this.closest('.swiper-slide').index());
		}
	});
}
